<template lang="pug">
  include ../Bemto
  +b.d-control-input__icon.--append(
    @click.prevent='appendIconFunc',
    :class="appendIcon"
  )
</template>
<script>
export default {
  name: 'AppendComponent',
  props: {
    appendIcon: {},
    appendIconFunc: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
